import { useContext, useEffect } from "react";
import { SportsCampsContext } from "../context/sportscamps-context";
import DateFilter from "./DateFilter";
import moment from 'moment';

const HolidayFilter = () => {
	const {
		dictionaryWords,
		sportsCamps,

		holidayCounter,
		setHolidayCounter,

		holiday,
		setHoliday,
		setFrom,
		setUntil,
		holidayButtonActive,
		setHolidayButtonActive,

		setFromValue,
		setUntilValue,
		setFromButtonActive,
		setUntilButtonActive,
	} = useContext(SportsCampsContext);

	useEffect(() => {
		if (sportsCamps.counters) {
			const holidayCounters = [];
			sportsCamps.counters.forEach((Type) => {
				if (Type.Type === "period") {
					const object = {};
					object["Period"] = Type.Name;
					object["From"] = Type.From;
					object["Until"] = Type.Until;
					object["Count"] = Type.Count;
					holidayCounters.push(object);
				}
			});
			setHolidayCounter(holidayCounters);
		}
	}, [JSON.stringify(sportsCamps.counters)]);

	const holidayFilterHandler = (event) => {
		if (event.target.nodeName === "BUTTON") {

			const fromDate =  moment(new Date(event.target.getAttribute("from")), 'YYYY-MM-DD HH:MM:SS').format('MM/DD/YYYY HH:MM:SS');
			const untilDate =  moment(new Date(event.target.getAttribute("until")), 'YYYY-MM-DD HH:MM:SS').format('MM/DD/YYYY HH:MM:SS');

			if (holiday === "") {
				setHoliday(event.target.id);
				setFrom(fromDate);
				setUntil(untilDate);
				setFromValue(new Date(fromDate));
				setUntilValue(new Date(untilDate));
				setFromButtonActive(true);
				setUntilButtonActive(true);
				setHolidayButtonActive(true);
			} else if (holiday !== event.target.id) {
				setHoliday(event.target.id);
				setFrom(fromDate);
				setUntil(untilDate);
				setFromValue(new Date(fromDate));
				setUntilValue(new Date(untilDate));
				setFromButtonActive(true);
				setUntilButtonActive(true);
				setHolidayButtonActive(true);
			} else if (holiday === event.target.id) {
				setHoliday("");
				setFrom("");
				setUntil("");
				setFromValue("");
				setUntilValue("");
				setFromButtonActive(false);
				setUntilButtonActive(false);
				setHolidayButtonActive(false);
			}
		}
	};

	const removeHolidayFilter = () => {
		setHoliday("");
		setFrom("");
		setUntil("");
		setFromValue("");
		setUntilValue("");
		setFromButtonActive(false);
		setUntilButtonActive(false);
		setHolidayButtonActive(false);
	};

	return (
		<div className="filter-section">
			<h3>{dictionaryWords.period}</h3>
			<>
			{sportsCamps.counters &&
				<>
					{holidayCounter.map((object) => (
						<div key={object.Period}>
							<button
								className={
									holidayButtonActive && holiday == object.Period
										? "active"
										: ""
								}
								id={object.Period}
								from={object.From}
								until={object.Until}
								onClick={holidayFilterHandler}
							>
								{object.Period}
								<span>{`(${object.Count})`}</span>
								<i
									className="fa fa-close"
									onClick={removeHolidayFilter}
								></i>
							</button>
						</div>
					))}
					<DateFilter />
				</>
			}
			</>
		</div>
	);
};

export default HolidayFilter;
